<div class="flex flex-wrap">
    <span
        class="inline-flex rounded-full items-baseline py-0.5 pl-2.5 pr-1 text-sm font-medium bg-primary-500 text-white"
        *ngIf="collection"
    >
        <span>In "{{ collection.name }}"</span>
        <a
            [routerLink]="['./']"
            [queryParams]="{ slug: undefined }"
            [queryParamsHandling]="'merge'"
            type="button"
            class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-gray-100 hover:bg-primary-800 hover:text-primary-50 focus:outline-none focus:bg-gray-600 focus:text-white"
        >
            <span class="sr-only">Remove filter</span>
            <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
            </svg>
        </a>
    </span>
    <ng-container *ngFor="let groupedIds of groupedActiveFacetValueIds">
        <span
            class="inline-flex rounded-lg items-baseline py-0.5 pl-2.5 pr-1 mr-2 text-sm font-medium bg-gray-200 text-gray-700"
        >
            <ng-container *ngIf="1 < groupedIds.length; else single">
                <span *ngIf="getFacetValue(groupedIds[0]) as facetValue" class="text-gray-500 mr-2">
                    {{ facetValue.facetName }}:</span
                >
                <ng-container *ngFor="let id of groupedIds; last as isLast">
                    <ng-container *ngIf="getFacetValue(id) as facetValue">
                        <span>{{ getFacetValue(id).name }}</span>
                        <a
                            [routerLink]="['./']"
                            [queryParams]="{ facets: toggleFacetValueId(facetValue.facetId, facetValue.id) }"
                            [queryParamsHandling]="'merge'"
                            [state]="{ noScroll: true }"
                            type="button"
                            class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-gray-500 hover:bg-gray-300 hover:text-gray-600 focus:outline-none focus:bg-gray-600 focus:text-white"
                        >
                            <span class="sr-only">Remove filter</span>
                            <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                                <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                            </svg>
                        </a>
                        <span *ngIf="!isLast" class="text-gray-500 mx-2">or</span>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-template #single>
                <ng-container *ngIf="getFacetValue(groupedIds[0]) as facetValue">
                    <span>
                        <span class="text-gray-500 mr-2">{{ facetValue.facetName }}:</span>
                        <span>{{ facetValue.name }}</span>
                    </span>
                    <a
                        [routerLink]="['./']"
                        [queryParams]="{ facets: toggleFacetValueId(facetValue.facetId, facetValue.id) }"
                        [queryParamsHandling]="'merge'"
                        [state]="{ noScroll: true }"
                        type="button"
                        class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-gray-500 hover:bg-gray-300 hover:text-gray-600 focus:outline-none focus:bg-gray-600 focus:text-white"
                    >
                        <span class="sr-only">Remove filter</span>
                        <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                            <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                        </svg>
                    </a>
                </ng-container>
            </ng-template>
        </span>
    </ng-container>
    <ng-container *ngIf="prices && (prices.min || prices.max)">
        <span
            class="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 mr-2 text-sm font-medium bg-green-100 text-gray-700"
        >
            <ng-template [ngIf]="prices.min && prices.max">
                Price: {{ prices.min | formatPrice }} - {{ prices.max | formatPrice }}
            </ng-template>
            <ng-template [ngIf]="prices.min && !prices.max">
                Price: at least {{ prices.min | formatPrice }}
            </ng-template>
            <ng-template [ngIf]="prices.max && !prices.min">
                Price: less than {{ prices.max | formatPrice }}
            </ng-template>
            <button
                (click)="removePriceFilter()"
                type="button"
                class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-green-600 hover:bg-green-200 hover:text-green-700 focus:outline-none focus:bg-green-700 focus:text-white"
            >
                <span class="sr-only">Remove large option</span>
                <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                    <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                </svg>
            </button>
        </span>
    </ng-container>
</div>
